import { defineMessages } from "react-intl";

export const authorizeStatusMessages = defineMessages({
  full: {
    defaultMessage: "Full",
    id: "F/JMp6",
    description: "authorize status full",
  },
  partial: {
    defaultMessage: "Partial",
    id: "EojeG7",
    description: "authorize status partial",
  },
  none: {
    defaultMessage: "None",
    id: "EoTI4r",
    description: "authorize status none",
  },
});

export const chargeStatusMessages = defineMessages({
  full: {
    defaultMessage: "Full",
    id: "UIM5bq",
    description: "charge status full",
  },
  partial: {
    defaultMessage: "Partial",
    id: "KPmk40",
    description: "charge status partial",
  },
  overcharged: {
    defaultMessage: "Overcharged",
    id: "ZOamBQ",
    description: "charge status overcharged",
  },
  none: {
    defaultMessage: "None",
    id: "dLIeRH",
    description: "charge status none",
  },
});

export const discountTypeMessages = defineMessages({
  fixed: {
    defaultMessage: "Fixed",
    id: "1/bAgt",
    description: "discount type fixed",
  },
  percentage: {
    defaultMessage: "Percentage",
    id: "+Wm2vY",
    description: "discount type percentage",
  },
  shipping: {
    defaultMessage: "Shipping",
    id: "UVDfTs",
    description: "discount type shipping",
  },
});

export const voucherStatusMessages = defineMessages({
  active: {
    defaultMessage: "Active",
    id: "EGycu/",
    description: "voucher status active",
  },
  expired: {
    defaultMessage: "Expired",
    id: "+470FM",
    description: "voucher status expired",
  },
  scheduled: {
    defaultMessage: "Scheduled",
    id: "qQih8j",
    description: "voucher status scheduled",
  },
});

export const collectionFilterMessages = defineMessages({
  published: {
    defaultMessage: "Published",
    description: "collection filter published",
    id: "UYKEsx",
  },
  hidden: {
    defaultMessage: "Hidden",
    description: "collection filter hidden",
    id: "ufahVh",
  },
});

export const staffMembersStatusMessages = defineMessages({
  active: {
    defaultMessage: "Active",
    description: "staff members status active",
    id: "nG1+Cz",
  },
  deactivated: {
    defaultMessage: "Deactivated",
    description: "staff members status deactivated",
    id: "SPF/Zn",
  },
});

export const productTypeMessages = defineMessages({
  digital: {
    defaultMessage: "Digital",
    description: "product type digital",
    id: "SgFE10",
  },
  shippable: {
    defaultMessage: "Shippable",
    description: "product type shippable",
    id: "M61TN/",
  },
});

export const attributeTypesMessages = defineMessages({
  productType: {
    defaultMessage: "Product type",
    id: "jzu97k",
    description: "attribute product type",
  },
  pageType: {
    defaultMessage: "Page type",
    id: "qT0qr/",
    description: "attribute page type",
  },
});
